/**
 * Sountsou 2026 - Formulaire de Contact
 * Amélioration progressive : le formulaire fonctionne nativement (POST vers admin-post.php,
 * rechargement de page) même sans JavaScript. Ce module intercepte la soumission pour
 * offrir une expérience sans rechargement, avec gestion des erreurs par champ.
 */

export function initContactForm(root = document) {
    const forms = root.querySelectorAll('.sountsou-contact-form');

    forms.forEach((form) => {
        if (form.dataset.contactInitialized === 'true') {
            return;
        }
        form.dataset.contactInitialized = 'true';

        // Formulaire désactivé (aperçu éditeur Gutenberg) : pas d'interception nécessaire
        if (form.dataset.preview === 'true') {
            return;
        }

        const blockEl = form.closest('.sountsou-contact-form-block');
        const statusEl = blockEl ? blockEl.querySelector('[data-contact-status]') : null;
        const submitBtn = form.querySelector('.sountsou-contact-form__submit');

        function clearFieldErrors() {
            form.querySelectorAll('.sountsou-contact-form__field-error').forEach((el) => el.remove());
            form.querySelectorAll('[aria-invalid="true"]').forEach((el) => el.removeAttribute('aria-invalid'));
        }

        function showFieldErrors(errors) {
            Object.keys(errors || {}).forEach((fieldName) => {
                const input = form.querySelector(`[name="${fieldName}"]`);
                if (!input) {
                    return;
                }
                input.setAttribute('aria-invalid', 'true');
                const wrapper = input.closest('.sountsou-contact-form__field');
                const message = document.createElement('p');
                message.className = 'sountsou-contact-form__field-error';
                message.textContent = errors[fieldName];
                (wrapper || input.parentNode).appendChild(message);
            });
        }

        function showStatus(type, message) {
            if (!statusEl) {
                return;
            }
            statusEl.hidden = false;
            statusEl.innerHTML = '';
            const p = document.createElement('p');
            p.className = `sountsou-contact-form__status-message sountsou-contact-form__status-message--${type}`;
            p.textContent = message;
            statusEl.appendChild(p);
            statusEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }

        form.addEventListener('submit', (e) => {
            e.preventDefault();
            clearFieldErrors();

            if (submitBtn) {
                submitBtn.setAttribute('disabled', 'disabled');
            }
            form.setAttribute('aria-busy', 'true');

            const formData = new FormData(form);

            fetch(form.getAttribute('action'), {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                body: formData,
            })
                .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
                .then(({ ok, data }) => {
                    if (ok && data && data.success) {
                        const successMessage = (data.data && data.data.message) || form.dataset.successMessage;
                        showStatus('success', successMessage);

                        // Événement GA4 de conversion : soumission réussie du formulaire de contact
                        if (typeof window.sountsouTrackEvent === 'function') {
                            const subjectEl = form.querySelector('[name="sountsou_subject"]');
                            const subjectValue = subjectEl ? subjectEl.value : 'general';
                            window.sountsouTrackEvent('generate_lead', {
                                event_category: 'Contact',
                                event_label: subjectValue,
                                form_id: form.getAttribute('id') || 'sountsou-contact-form',
                                form_name: 'Formulaire de Contact'
                            });
                        }

                        form.reset();
                        // Régénère l'horodatage anti-spam pour permettre un nouvel envoi
                        const tsField = form.querySelector('[name="sountsou_ts"]');
                        if (tsField) {
                            tsField.value = Math.floor(Date.now() / 1000);
                        }
                    } else {
                        const errorPayload = (data && data.data) || {};
                        showStatus('error', errorPayload.message || form.dataset.errorMessage);
                        showFieldErrors(errorPayload.errors);
                    }
                })
                .catch(() => {
                    showStatus('error', form.dataset.errorMessage);
                })
                .finally(() => {
                    if (submitBtn) {
                        submitBtn.removeAttribute('disabled');
                    }
                    form.removeAttribute('aria-busy');
                });
        });
    });
}

// Hook de rafraîchissement dynamique pour Gutenberg (ACF Block Preview)
if (typeof window !== 'undefined' && typeof window.acf !== 'undefined') {
    window.acf.addAction('render_block_preview/type=contact-form', function ($el) {
        if ($el && $el[0]) {
            initContactForm($el[0]);
        }
    });
}
